import * as URLConfig from "../domain";

const config = URLConfig.config;

const signupConfig = {
  taskLead: config.taskLead + config.jmw_content + "feedback/submit",
  vendor_req_a_call:
    config.jmw + config.jmw_content + "mysubscription/register",
  vendor_signup: config.key_clock_vendor + "vendor/users",
  openAccount: config.openNewAcc,
};

export default signupConfig;
